const userAgent = r => require.ensure([], () => r(require('@/page/userAgent')), 'userAgent');

export default [
  {
    path: '/userAgent',
    name: 'userAgent',
    component: userAgent
  }
];



// WEBPACK FOOTER //
// ./src/router/agent.js